import Bowser from "../../_scripts/plugins/bowser/src/bowser"

export default class DetectedBrowser {
  constructor() {
    this.browser = Bowser.getParser(window.navigator.userAgent);
    this.getBrowserName = this.browser.getBrowser().name;
    this.getBrowserVersion = parseFloat(this.browser.getBrowser().version);
  }

  checkSupportGrid() {
    switch (this.getBrowserName) {
      case 'Chrome':
        return this.getBrowserVersion >= 56
      case 'Firefox':
        return this.getBrowserVersion >= 52
      case 'Safari':
        return this.getBrowserVersion >= 10.1
      case 'Opera':
        return this.getBrowserVersion >= 43
      case 'Yandex':
        return this.getBrowserVersion >= 14
      default:
        break;
    }
  }
}